import {Component, NgZone} from '@angular/core';
import {Role} from '../../model/auth/Role';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Contest} from '../../model/contest/Contest';
import {NotificationHandler} from '../../helper/notification.handler';
import {ContestService} from '../../service/contest.service';
import {MatDialog} from '@angular/material/dialog';
import {TenantService} from '../../service/tenant.service';
import {ContestEnrollmentAwareComponent} from '../contest-enrollment-aware/contest-enrollment-aware.component';
import {TrackingService} from '../../service/tracking.service';
import {AuthService} from '../../service/auth.service';
import {User} from '../../model/auth/User';

@Component({
  selector: 'app-contests-history-list',
  templateUrl: './contests-history-list.component.html',
  styleUrls: ['./contests-history-list.component.scss']
})
export class ContestsHistoryListComponent extends ContestEnrollmentAwareComponent {

  readonly roles = [Role.Teacher, Role.Student];

  callerRoles?: Role[];
  user?: User | null;

  openContests!: Contest[] | null;
  openContestsForShow!: Contest[] | null;
  pastContests!: Contest[] | null;

  competitionId: string | undefined;

  openExpanded = true;
  historyExpanded = true;

  constructor(private contestService: ContestService,
              private tenantService: TenantService,
              private authService: AuthService,
              trackingService: TrackingService,
              ngZone: NgZone,
              dialogRef: MatDialog,
              breakpointObserver: BreakpointObserver) {
    super(trackingService, ngZone, breakpointObserver, dialogRef);
  }

  get showTeacherInfo(): boolean {
    return this.callerRoles?.includes(Role.Student) || false;
  }

  get showContestDetailsForTeacher(): boolean {
    return this.callerRoles?.includes(Role.Teacher) || false;
  }

  async initContent() {
    const tenant = this.tenantService.getTenant();
    if (tenant && tenant.id) {
      this.competitionId = tenant.id;
      this.loadOpenContests(this.competitionId);
      this.loadPastContests(this.competitionId);
    }
    this.user = await this.authService.getUser();
  }

  loadOpenContests(competitionId: string) {
    this.openContests = null;
    this.openContestsForShow = null;

    this.contestService.getOpenForEnrolContests(competitionId).subscribe(contests => {
      this.openContests = contests;
      this.openContestsForShow = contests;

      this.checkOpenAvailable();
    }, error => NotificationHandler.handleError($localize`:Notifications|Contests fetch has failed message@@notifications-contests-fetch-failed-error:Contests fetch has failed`, error));
  }

  loadPastContests(competitionId: string) {
    this.pastContests = null;

    this.contestService.getContests(competitionId).subscribe(contests => {
      this.pastContests = contests;

      this.historyExpanded = this.pastContests.length > 0;
      this.checkOpenAvailable();
    }, error => NotificationHandler.handleError($localize`:Notifications|Contests fetch has failed message@@notifications-contests-fetch-failed-error:Contests fetch has failed`, error));
  }

  contestsListUpdated(competitionId: string) {
    this.loadOpenContests(competitionId);
    this.loadPastContests(competitionId);
  }

  private checkOpenAvailable() {
    if (this.openContestsForShow && this.pastContests) {
      const noneAvailable = this.openContestsForShow.length == 0;
      const noneRegistered = this.pastContests.length == 0;

      const contests = new Set<string>();
      this.pastContests.forEach(c => contests.add(c.id));

      this.openContestsForShow = this.openContestsForShow.filter(c => !contests.has(c.id));
      this.openExpanded = this.openContestsForShow.length > 0 || (noneAvailable && noneRegistered);
    }
  }

  verifyPayment(contest: Contest) {
    if (this.user && this.callerRoles && this.callerRoles.length) {
      this.checkPaymentStatus(contest.id, this.user.id, this.callerRoles[0]);
    }
  }
}
